//Content.js
import React, { useState, useRef, useEffect, Component} from 'react';
import { globalConfig } from '../config/config';
import { Link, Grid, Card, CardActions, CardMedia, CardContent, Typography, TextField, Box } from '@mui/material';
import IconButton from "@mui/material/IconButton";
import Paper from "@mui/material/Paper";
import CircularProgress from "@mui/material/CircularProgress";
import Tooltip from "@mui/material/Tooltip";

// Icons — using unicode/SVG inline to avoid extra imports
const SendIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z" />
  </svg>
);

const UserIcon = () => (
  <Box
    sx={{
      width: 32,
      height: 32,
      borderRadius: "50%",
      background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: 0,
      fontSize: "13px",
      fontWeight: 700,
      color: "#fff",
      fontFamily: "'DM Sans', sans-serif",
    }}
  >
    You
  </Box>
);

const AIIcon = () => (
  <Box
    sx={{
      width: 32,
      height: 32,
      borderRadius: "50%",
      background: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: 0,
      fontSize: "11px",
      fontWeight: 700,
      color: "#fff",
      fontFamily: "'DM Sans', sans-serif",
    }}
  >
    G.AI
  </Box>
);

// Simulated AI response — replace with your actual API call
async function fetchAIResponse(prompt) {
  // Replace this with your real API call, e.g. Anthropic, OpenAI, etc.
  await new Promise((r) => setTimeout(r, 1200));
  return `This is a simulated AI response to your prompt:\n\n"${prompt}"\n\nReplace the fetchAIResponse function with your actual API call to connect this to a real AI model.`;
}




function Message({ role, content }) {
  const isUser = role === "user";
  return (
    <Box
      sx={{
        display: "flex",
        gap: 1.5,
        px: { xs: 2, md: 0 },
        alignItems: "flex-start",
        animation: "fadeSlideIn 0.3s ease",
        "@keyframes fadeSlideIn": {
          from: { opacity: 0, transform: "translateY(8px)" },
          to: { opacity: 1, transform: "translateY(0)" },
        },
      }}
    >
      {isUser ? <UserIcon /> : <AIIcon />}
      <Box sx={{ flex: 1 }}>
        <Typography
          variant="caption"
          sx={{
            fontFamily: "'DM Sans', sans-serif",
            fontWeight: 600,
            color: isUser ? "#667eea" : "#f5576c",
            textTransform: "uppercase",
            letterSpacing: "0.08em",
            fontSize: "11px",
            display: "block",
            mb: 0.5,
          }}
        >
          {isUser ? "You" : "Gazelle AI"}
        </Typography>
        <Paper
          elevation={0}
          sx={{
            p: 2,
            borderRadius: "4px 12px 12px 12px",
            background: isUser
              ? "rgba(102, 126, 234, 0.08)"
              : "rgba(255,255,255,0.04)",
            border: "1px solid",
            borderColor: isUser
              ? "rgba(102, 126, 234, 0.2)"
              : "rgba(255,255,255,0.08)",
            backdropFilter: "blur(8px)",
          }}
        >
          <Typography
            sx={{
              fontFamily: "'DM Mono', monospace",
              fontSize: "14px",
              lineHeight: 1.75,
              color: "#e2e8f0",
              whiteSpace: "pre-wrap",
              wordBreak: "break-word",
            }}
          >
            {content}
          </Typography>
        </Paper>
      </Box>
    </Box>
  );
}

function TypingIndicator() {
  return (
    <Box sx={{ display: "flex", gap: 1.5, alignItems: "flex-start", px: { xs: 2, md: 0 } }}>
      <AIIcon />
      <Box sx={{ flex: 1 }}>
        <Typography
          variant="caption"
          sx={{
            fontFamily: "'DM Sans', sans-serif",
            fontWeight: 600,
            color: "#f5576c",
            textTransform: "uppercase",
            letterSpacing: "0.08em",
            fontSize: "11px",
            display: "block",
            mb: 0.5,
          }}
        >
          AI Assistant
        </Typography>
        <Paper
          elevation={0}
          sx={{
            p: 2,
            borderRadius: "4px 12px 12px 12px",
            background: "rgba(255,255,255,0.04)",
            border: "1px solid rgba(255,255,255,0.08)",
            display: "inline-flex",
            alignItems: "center",
            gap: 0.5,
          }}
        >
          {[0, 1, 2].map((i) => (
            <Box
              key={i}
              sx={{
                width: 6,
                height: 6,
                borderRadius: "50%",
                background: "#f5576c",
                animation: "bounce 1.2s infinite",
                animationDelay: `${i * 0.2}s`,
                "@keyframes bounce": {
                  "0%, 80%, 100%": { transform: "scale(0.6)", opacity: 0.4 },
                  "40%": { transform: "scale(1)", opacity: 1 },
                },
              }}
            />
          ))}
        </Paper>
      </Box>
    </Box>
  );
}
const Content = () =>  {

// 	constructor(props)
// 	{
// 			console.log(props);
// 		    super(props);
	const initalState = {
				content : {
				"contentId":0,
				"contentImageFile":"",
				"contentImageFileType":0,	
				"contentTitle":"",
				"contentName":"",
				"inputSourceValueCode":0,
				"securityContextId":0,
				"createUser":0,
				"createDate": new Date(),
				"lastUpdateUser": 0,
				"lastUpdateDate": new Date(),
				"contentCdata":"",
				"contentBdata":"",
				"deleteFlag":0,
				"contentTypes":"",
				"proofingStatusCode":0,
				"proofingStatusMsg": "",
				"partNumber":"",
				"recordCount":0,
				"filesize":0,
				"uploadFileType":0,
				"platformEntryPoint":null,
				"serviceEntryPoint":null,
				"callbackEntryPoint":null,
				"httpMethod":null,
				"rate":0.0,
				"billingMethod":null,
				"authKey":null,
				"apiKey":null,
				"apiSecret":null,
				"version":null
			}
		}
// 	}

  const [messages, setMessages] = useState([]);
  const [prompt, setPrompt] = useState("");
  const [loading, setLoading] = useState(false);
  const messagesEndRef = useRef(null);
  const textFieldRef = useRef(null);

const [conversationHistory, setConversationHistory] = useState(['No conversations yet']);
const [userInput, setUserInput] = useState('Type here to chat with Dr. Gene.');

const handleUserInput = async (userInput2) => {

	console.log('handling user input now');
	setConversationHistory('Please wait, while I get you an answer!');
	let url = 'https://origohealthghana.gazelleplatform.com/services/security/anthropic-service/prompt';
	try {
		const prePrompt = 'You are a technology expert in the areas of software development, data management, digital transformation and business consulting. Your past roles include technology architect, cto, cio, ciso. A client is asking about the following technical issuesand needs your expert advice. In your response, do not format the text to look like a human typed response and do not include characters like #, -, *, and ** to iterate response lines and to indicated section headers, rather use bullets and numbers to make the response look human and natural. also use a different font size for section headers. Heres is the clients inquiry:';
		const finalPrompt = prePrompt + ' ' + userInput2;
		console.log(finalPrompt);
      const response = await axios.post(
        `${url}`,
		{
    		"model": "claude-opus-4-6",
    		"max_tokens": 1024,
    		"messages": [
        		{"role": "user", "content": finalPrompt}
    		]
		})

      if (response?.status === 200) {
        if (response?.data?.content[0].text) {
          setConversationHistory(response?.data?.content[0].text);
          return conversationHistory;
        }
      }
    } 
    catch (error) 
    {
      console.log({ error })

      if (error.response.status === 401) {
        addToast('Something went wrong, please try again', {
          autoDismiss: true,
          appearance: 'error',
        })
      } else {
        console.log(error.response.data.errors)
        error.response.data.errors.forEach(el => {
          addToast(el.msg, {
            autoDismiss: true,
            appearance: 'error',
          })
        })
      }
    }
};
  // Auto-scroll to bottom on new messages
  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages, loading]);

  const handleSubmit = async () => {
    const trimmed = prompt.trim();
    if (!trimmed || loading) return;

    setMessages((prev) => [...prev, { role: "user", content: trimmed }]);
    setPrompt("");
    setLoading(true);

    try {
      const response = await handleUserInput(trimmed);
      setMessages((prev) => [...prev, { role: "ai", content: response }]);
    } catch {
      setMessages((prev) => [
        ...prev,
        { role: "ai", content: "⚠️ Something went wrong. Please try again." },
      ]);
    } finally {
      setLoading(false);
      textFieldRef.current?.focus();
    }
  };

  const handleKeyDown = (e) => {
    // Submit on Enter, new line on Shift+Enter
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSubmit();
    }
  };

//     render(){

        return (
        	<>

    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100vh",
        background: "linear-gradient(160deg, #0f0c29 0%, #1a1a2e 50%, #16213e 100%)",
        fontFamily: "'DM Sans', sans-serif",
        position: "relative",
        overflow: "hidden",
        // Subtle grid overlay
        "&::before": {
          content: '""',
          position: "absolute",
          inset: 0,
          backgroundImage:
            "linear-gradient(rgba(255,255,255,0.015) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.015) 1px, transparent 1px)",
          backgroundSize: "40px 40px",
          pointerEvents: "none",
        },
      }}
    >
      {/* Header */}
      <Box
        sx={{
          px: 3,
          py: 2,
          borderBottom: "1px solid rgba(255,255,255,0.07)",
          backdropFilter: "blur(12px)",
          background: "rgba(15,12,41,0.6)",
          display: "flex",
          alignItems: "center",
          gap: 1.5,
          zIndex: 10,
        }}
      >
        <Box
          sx={{
            width: 8,
            height: 8,
            borderRadius: "50%",
            background: "#f5576c",
            boxShadow: "0 0 10px #f5576c",
          }}
        />
        <Typography
          sx={{
            fontFamily: "'DM Sans', sans-serif",
            fontWeight: 700,
            fontSize: "15px",
            color: "#e2e8f0",
            letterSpacing: "0.02em",
          }}
        >
          Gazelle AI
        </Typography>
        <Box sx={{ flex: 1 }} />
        <Typography
          sx={{
            fontSize: "11px",
            color: "rgba(255,255,255,0.3)",
            fontFamily: "'DM Mono', monospace",
          }}
        >
          {messages.length} messages
        </Typography>
      </Box>

      {/* Messages area — scrollable */}
      <Box
        sx={{
          flex: 1,
          overflowY: "auto",
          display: "flex",
          flexDirection: "column",
          gap: 3,
          py: 4,
          px: { xs: 2, md: "25%" },
          // Custom scrollbar
          "&::-webkit-scrollbar": { width: "4px" },
          "&::-webkit-scrollbar-track": { background: "transparent" },
          "&::-webkit-scrollbar-thumb": {
            background: "rgba(255,255,255,0.1)",
            borderRadius: "4px",
          },
        }}
      >
        {messages.length === 0 && (
          <Box
            sx={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              gap: 2,
              opacity: 0.4,
              userSelect: "none",
              mt: "20vh",
            }}
          >
            <Typography
              sx={{
                fontSize: "48px",
                lineHeight: 1,
              }}
            >
              ✦
            </Typography>
            <Typography
              sx={{
                fontFamily: "'DM Sans', sans-serif",
                fontSize: "16px",
                color: "#e2e8f0",
                textAlign: "center",
              }}
            >
              Start a conversation
            </Typography>
            <Typography
              sx={{
                fontFamily: "'DM Mono', monospace",
                fontSize: "12px",
                color: "rgba(255,255,255,0.4)",
                textAlign: "center",
              }}
            >
              Press Enter to send · Shift+Enter for new line
            </Typography>
          </Box>
        )}

        {messages.map((msg, i) => (
          <Message key={i} role={msg.role} content={msg.content} />
        ))}

        {loading && <TypingIndicator />}

        <div ref={messagesEndRef} />
      </Box>

      {/* Prompt input — pinned to bottom */}
      <Box
        sx={{
          px: { xs: 2, md: "25%" },
          py: 3,
          borderTop: "1px solid rgba(255,255,255,0.07)",
          background: "rgba(15,12,41,0.8)",
          backdropFilter: "blur(16px)",
          zIndex: 10,
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "flex-end",
            gap: 1.5,
            background: "rgba(255,255,255,0.04)",
            border: "1px solid rgba(255,255,255,0.1)",
            borderRadius: "12px",
            p: 1.5,
            transition: "border-color 0.2s",
            "&:focus-within": {
              borderColor: "rgba(102,126,234,0.5)",
              boxShadow: "0 0 0 3px rgba(102,126,234,0.1)",
            },
          }}
        >
          <TextField
            inputRef={textFieldRef}
            multiline
            maxRows={10}
            minRows={1}
            value={prompt}
            onChange={(e) => setPrompt(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder="How can I help?..."
            variant="standard"
            fullWidth
            disabled={loading}
            InputProps={{ disableUnderline: true }}
            sx={{
              "& .MuiInputBase-root": {
                fontFamily: "'DM Mono', monospace",
                fontSize: "14px",
                color: "#e2e8f0",
                lineHeight: 1.75,
                px: 0.5,
              },
              "& .MuiInputBase-input::placeholder": {
                color: "rgba(255,255,255,0.25)",
                opacity: 1,
              },
            }}
          />
          <Tooltip title="Send (Enter)">
            <span>
              <IconButton
                onClick={handleSubmit}
                disabled={!prompt.trim() || loading}
                size="small"
                sx={{
                  width: 36,
                  height: 36,
                  borderRadius: "8px",
                  background:
                    prompt.trim() && !loading
                      ? "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
                      : "rgba(255,255,255,0.06)",
                  color: prompt.trim() && !loading ? "#fff" : "rgba(255,255,255,0.2)",
                  transition: "all 0.2s",
                  flexShrink: 0,
                  "&:hover": {
                    background:
                      prompt.trim() && !loading
                        ? "linear-gradient(135deg, #7b93f5 0%, #8a5bbf 100%)"
                        : "rgba(255,255,255,0.06)",
                    transform: prompt.trim() && !loading ? "scale(1.05)" : "none",
                  },
                }}
              >
                {loading ? (
                  <CircularProgress size={14} sx={{ color: "rgba(255,255,255,0.3)" }} />
                ) : (
                  <SendIcon />
                )}
              </IconButton>
            </span>
          </Tooltip>
        </Box>
        <Typography
          sx={{
            fontSize: "11px",
            color: "rgba(255,255,255,0.2)",
            fontFamily: "'DM Mono', monospace",
            textAlign: "center",
            mt: 1.2,
          }}
        >
          Enter ↵ to send · Shift+Enter for new line
        </Typography>
      </Box>
    </Box>
    <hr />
        		{/* 
					<iframe src="https://p.us5.datadoghq.com/sb/embed/60d955af-6641-11f0-850f-12cb51e282ae-2296e802cb7296254e603a5ed6e55528" title="Dashboard Name" width="800" height="800">
					</iframe>

    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        px: 2,
        py: 4,
      }}
    >
      <TextField
        multiline
        rows={4}
        placeholder="How can I help?"
        variant="outlined"
        fullWidth
        sx={{
          width: '50%',
          '& .MuiOutlinedInput-root': {
            borderRadius: 2,
          },
        }}
      />
    </Box>

				*/}

					<Grid container spacing={2}
					justifyContent="center" // ← Horizontal centering
  					sx={{
    					width: '100%', // Ensure container takes full width
    					margin: '0 auto' // Optional: Center the grid itself if needed
  					}}>
  					<Grid item>
					<Card variant="outlined" 
						sx={{ width: 350, height: 200 }}
						elevation={10}
					>
						
						<center>
																<a href="/neo" target="_self">
																	<img src="/images/DashboardIcon/Icon/neo.png" />
																	<br />
																</a>
							<Typography variant="subtitle1" gutterBottom>
    							<Link href="/neo">Integration</Link>
  							</Typography>
							<Typography variant="body2" sx={{ color: 'text.secondary' }}>
								Create smart agents to data sources for automation and driving insights.
  							</Typography>
														</center>
					</Card>	
					</Grid>
					<Grid item>														
					<Card variant="outlined" 
						sx={{ width: 350, height: 200 }}
						elevation={10}
					>
						<center>
															<a href="/dynamo" target="_self">
																<img src="/images/DashboardIcon/Icon/dynamo.png" />
															</a>

							<Typography variant="subtitle1" gutterBottom>
    								<Link href="/dynamo">Intelligent Manipulation</Link>
  							</Typography>
							<Typography variant="body2" sx={{ color: 'text.secondary' }}>
									Drives intelligent autonomy by wiring up data services, agents and 
									AI algorithms to accelerate intelligent transformations.
  							</Typography>
														</center>
						
					</Card>															
					</Grid>
					<Grid item>														
					<Card variant="outlined" 
						sx={{ width: 350, height: 200 }}
						elevation={10}
					>
						<center>
															<a href="/breeze" target="_self">
																<img src="/images/DashboardIcon/Icon/breeze.png" />
															</a>
							<Typography variant="subtitle1" gutterBottom>
    								<Link href="/breeze">Information Catalog</Link> 
  							</Typography>
							<Typography variant="body2" sx={{ color: 'text.secondary' }}>
									Classify, tag, catalog and control any type of data with ridiculous precision. 
  							</Typography>
														</center>
														
						
					</Card>															
					</Grid>
					<Grid item>														
					<Card variant="outlined" 
						sx={{ width: 350, height: 200  }}
						elevation={10}
					>
						<center>
															<a href="/waves" target="_self">
																<img src="/images/DashboardIcon/Icon/waves.png" />
															</a>
							<Typography variant="subtitle1" gutterBottom>
    								<Link href="/waves">Version Management</Link> 
  							</Typography>
							<Typography variant="body2" sx={{ color: 'text.secondary' }}>
									Control versions of your data, agents, services and objects
  							</Typography>
														</center>
						
					</Card>															
					</Grid>

					<Grid item>														
					<Card variant="outlined" 
						sx={{ width: 350, height: 200  }}
						elevation={10}
					>
						<center>
							<a href="/eqius" target="_self">
								<img src="/images/DashboardIcon/Icon/equis.png" />
							</a>
							<Typography variant="subtitle1" gutterBottom>
    								<Link href="/eqius">Business Services</Link> 
  							</Typography>
							<Typography variant="body2" sx={{ color: 'text.secondary' }}>
									An integrated stack of standard business applications.
  							</Typography>
						</center>
						
					</Card>															
					</Grid>
  					<Grid item>
					<Card variant="outlined" 
						sx={{ width: 350, height: 200 }}
						elevation={10}
					>
						
						<center>
							<a href="/telony" target="_self">
								<img width="80" src="/images/DashboardIcon/Icon/ManageContentTypes.png" />
								<br />
							</a>
							<Typography variant="subtitle1" gutterBottom>
    							<Link href="/learning-center">Learning Center</Link>
  							</Typography>
							<Typography variant="body2" sx={{ color: 'text.secondary' }}>
								Continuous Learning With Online Courses, Seminars and Workshops
  							</Typography>
						</center>
					</Card>	
					</Grid>
  					<Grid item>
					<Card variant="outlined" 
						sx={{ width: 350, height: 200 }}
						elevation={10}
					>
						
						<center>
							<a href="/telony" target="_self">
								<img width="300" src="/images/DashboardIcon/Icon/telonylogo.png" />
								<br />
							</a>
							<Typography variant="subtitle1" gutterBottom>
    							<Link href="/telony">Infrastructure</Link>
  							</Typography>
							<Typography variant="body2" sx={{ color: 'text.secondary' }}>
								Monitor and manage your servers, network and infrastructure services.
  							</Typography>
						</center>
					</Card>	
					</Grid>
					</Grid>		

				

            </>
			)
// 		}
	}
	
export default Content;